module.exports = __webpack_public_path__ + "img/ios-17-accessibility-features.2be4d627.png";